import error from '@/model/error';
import preloader from '@/model/preloader';
import OperationRunner from './OperationRunner';
// fixme
export default function () {
  OperationRunner.setStoreFunctions(
    () => preloader.add(),
    id => preloader.remove(id),
    e => error.add(e),
  );
}
